import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get('order_id');

  const handleReturnToCheckout = () => {
    navigate('/checkout');
  };

  const handleContinueShopping = () => {
    navigate('/');
  };

  const handleViewCart = () => {
    navigate('/cart');
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-sm">
            <div className="card-body text-center p-5">
              <div className="mb-4">
                <div 
                  style={{
                    width: '80px',
                    height: '80px',
                    backgroundColor: '#ffc107',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    fontSize: '40px',
                    color: 'white'
                  }}
                >
                  ⚠
                </div>
              </div>
              
              <h1 className="text-warning mb-3">Payment Cancelled</h1>
              <p className="lead mb-4">
                You have cancelled the payment process. No charges have been made to your card.
              </p>

              {orderId && (
                <div className="bg-light p-3 rounded mb-4">
                  <small className="text-muted">Order ID: <strong>{orderId}</strong></small>
                  <br />
                  <small className="text-muted">This order has not been processed</small>
                </div>
              )}

              <div className="alert alert-info">
                <h6>Your Cart Items Are Still Saved</h6>
                <p className="mb-0">
                  Don't worry! All items in your cart are still there. 
                  You can continue shopping or try completing your purchase again.
                </p>
              </div>

              <div className="mt-4">
                <button 
                  className="btn btn-primary btn-lg me-3"
                  onClick={handleReturnToCheckout}
                >
                  Try Again
                </button>
                <button 
                  className="btn btn-outline-secondary btn-lg me-3"
                  onClick={handleViewCart}
                >
                  View Cart
                </button>
                <button 
                  className="btn btn-outline-primary btn-lg"
                  onClick={handleContinueShopping}
                >
                  Continue Shopping
                </button>
              </div>

              <div className="mt-4 pt-3 border-top">
                <h6>Need Help?</h6>
                <p className="text-muted mb-2">
                  If you're having trouble completing your payment, please contact our support team.
                </p>
                <button 
                  className="btn btn-link"
                  onClick={() => window.location.href = 'mailto:support@yourdomain.com'}
                >
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;